import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { PataviumRole } from '../../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import { ISms } from '../../../../../models/request-and-responses/rest-api/interfaces/sms.interface';
import { IUser } from '../../../../../models/request-and-responses/rest-api/interfaces/user';
import { DataService } from '../../../../../services/data.service';

@Component({
    selector: 'app-superadmin-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class SuperadminModalComponent implements OnInit {

    @Input() id;
    @Input() operation;
    @Input() title;
    public searchTerm$ = new Subject<string>();

    public template: ISms;
    public users: IUser[];
    public copyOfUsers: IUser[];
    public selectAll = false;
    public search_value;
    public linkedUsers;
    public isLoading = false;

    constructor(
        public activeModal: NgbActiveModal,
        private toastr: ToastrService,
        private dataService: DataService
        ) {

            this.searchTerm$
            .debounceTime(400)
            .distinctUntilChanged()
            .subscribe((term) => {

                this.filterList(term);
                
            });
      
    }


    ngOnInit() {

        this.initData();

    }


    async initData() {

        try {

            switch(this.operation) {

                case 'new':

                    break;

                case 'edit':

                    this.isLoading = true;

                    this.template = await this.dataService.getTemplate(this.id);

                    this.isLoading = false;
                    break;

                case 'remove':

                    this.isLoading = true;

                    this.template = await this.dataService.getTemplate(this.id);

                    this.isLoading = false;

                    break;

                case 'link':

                    this.isLoading = true;

                    this.template = await this.dataService.getTemplate(this.id);

                    this.linkedUsers = await this.dataService.getTemplateUser(this.id);

                    switch(this.template.recipient) {

                        case 'venditore':

                            this.users = await this.dataService.getUsersByRole(PataviumRole.Agent);

                            break;

                        case 'team':

                            this.users = await this.dataService.getUsersByRole(PataviumRole.Agency);

                            break;

                        case 'operatore_team':

                            this.users = await this.dataService.getUsersByRole(PataviumRole.AgencyOperator);

                            break;

                        case 'operatore':

                            this.users = await this.dataService.getUsersByRole(PataviumRole.BackOfficeOperator);

                            break;

                        default:

                    }

                    if (this.users && this.users.length) {

                        for (let u = 0; u < this.users.length; u++) {

                            if(await this.linkedUsers.some((lu) => {

                                return lu.id === this.users[u].id;
    
                            })) {

                                this.users[u].selected = await true;

                            } else {

                                this.users[u].selected = await false;

                            }

                        }

                    }

                    this.selectAll = await this.users.every((user) => {

                        return user.selected === true;

                    });

                    this.copyOfUsers = await JSON.parse(JSON.stringify(this.users));

                    this.isLoading = false;

                    break;

                default:

            }

        } catch (err) {

            console.log(err)

            this.toastr.error(`Errore durante il completamento dell'operazione.`);

        }

    }


    async confirmAction(form) {

        try {

            switch(this.operation) {

                case 'new':

                    this.isLoading = true;

                    await this.dataService.addTemplate(form);

                    await this.toastr.success("Template creato con successo");

                    await this.activeModal.close(true);

                    this.isLoading = false;

                    break;

                case 'edit':

                    this.isLoading = true;

                    form.Id = this.id;

                    await this.dataService.updateTemplate(form);

                    await this.toastr.success("Template aggiornato con successo");

                    await this.activeModal.close(true);

                    this.isLoading = false;

                    break;

                case 'remove':

                    this.isLoading = true;

                    await this.dataService.removeTemplate(this.id);

                    await this.toastr.success("Template rimosso con successo");

                    await this.activeModal.close(true);

                    this.isLoading = false;

                    break;

                case 'link':

                    this.isLoading = true;

                    if (this.copyOfUsers && this.copyOfUsers.length) {

                        let ids = [];

                        for (let i = 0; i < this.users.length; i++) {

                            let idx = await this.copyOfUsers.findIndex((cu) => {

                                return cu.id === this.users[i].id;

                            });

                            if (idx !== -1) {

                                this.users[i].selected = await this.copyOfUsers[idx].selected;

                            }

                            if (this.users[i].selected && this.users[i].selected === true) await ids.push(this.users[i].id);

                        }

                        await this.dataService.linkTemplate({ id: this.id, ids });

                        await this.toastr.success("Associazione aggiornata con successo");
    
                        await this.activeModal.close(true);


                    } else {

                        await this.toastr.warning("Attenzione selezionare almeno 1 utente da associare");

                        return false;

                    }

                    this.isLoading = false;

                    break;

                default:

            }

        } catch (err) {

            this.isLoading = false;

        }

    }

    checkAll() {


        if (this.selectAll === true) {

            this.copyOfUsers.map(user => {
                user.selected = true;
            });

            this.selectAll = true;

        } else {

            this.copyOfUsers.map(user => {
                user.selected = false;
            });

            this.selectAll = false;

        }

    }

    closeModal() {
        this.activeModal.close();
        this.selectAll = false;
    }


    async filterList(term) {

        if (term) {

            this.copyOfUsers = await this.users.filter((user) => {

                return (user.firstName && (user.firstName.toLowerCase()).includes(term.toLowerCase())) || (user.lastName && (user.lastName.toLowerCase()).includes(term.toLowerCase()));
    
            });

        } else {

            this.copyOfUsers = await JSON.parse(JSON.stringify(this.users));

        }   

    }

   
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/superadmin/templates/modal/modal.component.ts